import React, { Component } from "react";
import {  Form, Container, Row, Col, Button } from "react-bootstrap";
import LeaseList from "containers/property/LeaseList";
import 'containers/common/Detail.css';
import Select from 'react-select';
import { API } from "aws-amplify";
import axios from 'axios';
import { PacmanLoader } from 'react-spinners';


const CancelToken = axios.CancelToken;
const source = CancelToken.source();
export default class LeaseSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,


            propertyid: "",
            name: "",
            leasenumber: "",
            state: "",
            archiveOptions: [{value: false, label: "Exclude archived"}, {value: true, label: "Archived only"}, {value: null, label: "All leased including archived"}],
            selectedArchiveOption: {value: false, label: "Exclude archived"},
            isLoading: false,
            leases: [],
            leaseClassificationOptions: [],
            archived: false,
            filter: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        try {
            console.log(this.state.filter);
            // const leases = await this.getLeases(this.state.filter);
            // leases.sort((a,b) => {if(a.lessee_trading < b.lessee_trading) {return -1;} 
            //                      if(a.lessee_trading > b.lessee_trading) {return 1}
            //                      return 0});
            // this.setState({ leases });

           
        } catch (e) {
            alert(e);
        }

        document.title = "Cityscope Lease Search";
        this.setState({ isLoading: false });      
    }

    //API
    getLeases(filter) {
        console.log("Inside getLeases()");

        console.log(filter);

        //  this.setState({ searching : true });

        return API.get("colin", "/leases", { 'queryStringParameters': filter, 'cancelToken': source.token } );
    }
    



        
    handleChange = event => {
        
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }


    handleDateChange(date, name) {
        if (date) {
            this.setState({
                [name]: new Date(date)
            });
        }
        else {
            this.setState({
                [name]: null
            });
        }
        this.setState({ modified: true });
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })

        

    }

    async clearFilters() {
        this.setState({
              propertyid: ""
            , name: ""
            , leasenumber: ""
            , state: ""
            , archived: null
            , filter: {
                user: this.props.user,
                screen: "property"
            }
        });
    }

    handleArchiveChange = (selectedArchiveOption) => {
        this.setState({ selectedArchiveOption });
        if (selectedArchiveOption) {
            this.setState({ archived: selectedArchiveOption.value 
                             });
        }
        else {
            this.setState({ archived: null
                            });
        }        
    }

    async handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
 

        const leases = await this.getLeases({
                            propertyid: this.state.propertyid,
                            name: this.state.name,
                            leasenumber: this.state.leasenumber,
                            state: this.state.state,
                            archived: this.state.archived
        } );
        leases.sort((a,b) => (a.lessee_trading > b.lessee_trading) ? 1 : ((b.lessee_trading > a.lessee_trading) ? -1 : 0));
        this.setState({ leases });
        this.setState({ isLoading: false });     



     }

    renderLeases() {
        return (
            
                <Container fluid >       
                <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Lease Search
                                </h6>
                    
                        </Col>
                    </Row>
                  <Form onSubmit={this.handleSubmit}>  
               <Row>        
             
                    


                                <Col >
                                <Form.Group  controlId="propertyid">
                                    <Form.Control
                                        value={this.state.propertyid}
                                        onChange={this.handleChange}
                                        as="input"
                                        type="text"
                                        placeholder="Cityscope Reference starting"
                                    />
                                </Form.Group>
                                </Col>
                                <Col lg={3}>
                                    
                                    <Form.Group controlId="name">
                                        <Form.Control
                                            type="input"
                                            value={this.state.name}
                                            onChange={this.handleChange}
                                            placeholder="Tentant Name starting" />
                                    </Form.Group>
                                </Col>
                            
                                <Col lg={1}>
                                    <Form.Group controlId="leasenumber">
                                        <Form.Control
                                            type="input"
                                            value={this.state.leasenumber}
                                            onChange={this.handleChange}
                                            placeholder="Lease No. containing" />
                                            </Form.Group>
                                        
                                </Col>
                            
                                <Col >
                                <Form.Group controlId="state">
                                        <Form.Control
                                            type="input"
                                            value={this.state.state}
                                            onChange={this.handleChange}
                                            placeholder="State" />
                                    
                                    </Form.Group>
                                </Col>
                            
                                <Col >
                                <Form.Group controlId="archived">
                                    <Select
                                        value={this.state.selectedArchiveOption}
                                        onChange={this.handleArchiveChange}
                                        options={this.state.archiveOptions}
                                        
                                    />
                                    </Form.Group>
                                </Col>
                            
                            <Col >
                                <Button type="submit" id="submit" >Search</Button>
                            </Col>
                            <Col >
                                <Button  onClick={this.clearFilters}>Clear Filters</Button>
                            </Col>
                            
                </Row>
                </Form> 
                <Row>
                <Col>
                {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css="display: block;
                            margin: 0 auto;
                             border-color: red"
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                        />
                </div>
                    </div>}
                    {!this.state.isLoading &&
                    <LeaseList
                        isAuthenticated={this.props.isAuthenticated}
                        user={this.props.user}
                        data={this.state.leases}
                        updateTableState={this.updateTableState}
                        saveRecord={this.saveRecord}
                        deleteRecord={this.deleteRecord}
                        refreshDataSet={this.refreshDataSet}
                        validateRelatedRecord={this.validateRelatedRecord}
                        leaseClassificationOptions={this.state.leaseClassificationOptions}
                        propertyid={this.state.property_id}
                        propertykey={this.state.property_key}
                        controlType="table2"
                    />
                    }
                </Col>
                </Row> 

                </Container>

        );
    }
  render() {
    return (

        <div className="LeaseSearch">
            {this.props.isAuthenticated  && this.props.user ? this.renderLeases() : console.log("error)")}
        </div>
    );
  }
}
